import React from "react";
import { makeStyles, IconButton, Slide } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Slider from "react-slick"
import Chip from '@material-ui/core/Chip';
import CloseIcon from '@material-ui/icons/Close';
import Button from "./Button";
const Transition = React.forwardRef((props, ref)=> <Slide direction="up" ref={ref} {...props} />);
const useStyles = makeStyles((theme) => ({
  root: {
    padding: 20,
    backgroundColor: `yellow`,
    position: `absolute`,
    top: `100%`,
    right: 40,
    transform: `translateY(-50%)`,
    fontSize: 20,
    "&:hover": {
      backgroundColor: `yellow`,
    },
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
  popup:{
    "& .MuiDialog-paper": {
      borderRadius: `6.7rem`,
      WebkitBorderRadius: `6.7rem`,
      overflow: `hidden`,
      margin: `2rem 1.25rem`,
      WebkitMaskImage: "-webkit-radial-gradient(white, black)",
      WebkitBackfaceVisibility: "hidden",
      MozBackfaceVisibility: "hidden",
      WebkitTransform: "translate3d(0, 0, 0)",
      MozTransform: "translate3d(0, 0, 0)"
    }
  },
  floating:{
    position: `fixed`,
    right: `2rem`,
    top: `2rem`,
    zIndex: 10000,
    color: `#fff`
  },
  chip: {
    color: `#fff`,
    margin: 5
  },
  rounded:{
    borderRadius: `6.5rem`,
    WebkitBorderRadius: `6.5rem`,
    width: `100%`,
    overflow: `hidden`
  }
}));

const Popup = ({ open = false, handleClose, active }) => {
  const classes = useStyles();
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll="paper"
      TransitionComponent={Transition}
      className={classes.popup}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <IconButton className={classes.floating} onClick={handleClose}>
      <CloseIcon />
    </IconButton>
      <div className="popup rounded-0 mask" style={{overflowX: `hidden`}}>
      <div
        className="position-relative mask mb-2 rounded-0"
      >
        <Slider className="mask" {...settings}>
          {active?.photos?.map((el,i)=>(
            <div key={i}
            className="height mask h-100 position-relative">
              {el.type === "image" ? <img src={el.src} className={`mask ${classes.rounded}`} alt={active.name}/> : el.type === "video" ?<video autoPlay loop playsInline className={`w-100 h-100 overflow-hidden mask ${classes.rounded}`} src={el?.src}></video> : <div>The File You've uploaded is not Correct</div> }
            </div>
          ))}
        </Slider>
        
      </div>
        <DialogTitle>
          <Typography component="span" variant="h3">{active.name}</Typography>
          <br/>
          <Typography component="span" variant="h4">{active.price}</Typography>
        </DialogTitle>
      <DialogContent>
        <div className="content" dangerouslySetInnerHTML={{__html: active.description}} />
        <div className="my-3">
          {Object.entries(active?.tags || {}).map((el,i)=>
            <Chip key={i} className={` ${classes.chip}`} variant="default" color="primary" label={`${el[0]}: ${el[1]}`} />
          )}
        </div>
      </DialogContent>
      <DialogActions className="text-center justify-content-center">
        <Button size="large" endIcon=">" component="a" target="_blank" rel="" href={active.website} variant="contained" color="primary">
          Book Now
        </Button>
      </DialogActions>
      </div>
    </Dialog>
  );
};

export default Popup;
